import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';

import styles from './ModalWrapper.module.scss';

import { modalManager } from '@/libs/ModalContainer';

const cx = classNames.bind(styles);

const ModalWrapper = ({ disableEscape = false, className, children }) => {
  const [show, setShow] = useState(false);

  useMountEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 100);

    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  });

  const onKeyDown = (e) => {
    if (!disableEscape && e.code === 'Escape') {
      close();
    }
  };

  const close = () => {
    if (disableEscape) return;

    modalManager.hide();
  };

  return (
    <div className={cx('container')}>
      <div className={cx('dim')} onClick={close} />
      <div className={cx(['modal', className, { show }])}>{children}</div>
    </div>
  );
};

export default ModalWrapper;
